<template>
  <div
    class="cursor-default bg-white rounded-xl p-5 shadow-sm border border-gray-200"
  >
    <div class="flex items-start gap-4">
      <img
        v-if="company.logo"
        :src="company.logo"
        :alt="`${company.name} logo`"
        class="w-16 h-16 rounded-lg object-contain bg-gray-50"
      />
      <div
        v-else
        class="w-16 h-16 rounded-lg bg-gray-100 flex items-center justify-center"
      >
        <Building class="w-8 h-8 text-gray-400" />
      </div>

      <div class="flex-1">
        <div class="flex flex-col gap-1">
          <h3 class="text-lg text-gray-900">{{ company.name }}</h3>
          <a
            v-if="company.job_board_url"
            :href="company.job_board_url"
            class="inline-flex items-center hover:underline text-sm text-neutral-500 hover:text-cosmicPurple"
            target="_blank"
            rel="noopener noreferrer"
            @click.stop
          >
            Company job board
            <ExternalLink class="w-3.5 h-3.5 ml-1" />
          </a>
        </div>
        <div class="flex flex-wrap gap-2 mt-3 text-xs">
          <a
            :href="getTrackTalentUrl(company.id)"
            class="inline-flex items-center rounded-full bg-cosmicPurple/10 text-cosmicPurple px-2.5 py-1 hover:bg-cosmicPurple/20"
            target="_blank"
            rel="noopener noreferrer"
            @click.stop
          >
            {{ company.open_role_count }} Jobs on TrackTalent
          </a>
          <a
            :href="getInterviewWatchUrl(company.id)"
            class="inline-flex items-center rounded-full bg-blue-100 text-blue-700 px-2.5 py-1 hover:bg-blue-200"
            target="_blank"
            rel="noopener noreferrer"
            @click.stop
          >
            {{ company.interview_count }} Interview Logs
          </a>
          <a
            :href="getOffersUrl(company.id)"
            class="inline-flex items-center rounded-full bg-lime-100 text-lime-700 px-2.5 py-1 hover:bg-lime-200"
            target="_blank"
            rel="noopener noreferrer"
            @click.stop
          >
          <Trophy class="w-3.5 h-3.5 mr-1" />
            {{ company.offer_count }} Fellow Offers
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Building, ExternalLink, Trophy } from 'lucide-vue-next'
import type { ReferringCompany } from '@/types/company'

const props = defineProps<{
  company: ReferringCompany
}>()

const emit = defineEmits<{
  (event: 'click', id: number): void
}>()

const getTrackTalentUrl = (companyId: number) =>
  `https://tracktalent.outtalent.com/jobs?status=true&employer_ids=${encodeURIComponent(
    companyId.toString()
  )}&page=1`

const getInterviewWatchUrl = (companyId: number) =>
  `https://interviewwatch.outtalent.com/?employers=${encodeURIComponent(companyId.toString())}`

const getOffersUrl = (companyId: number) =>
  `https://offers.outtalent.com/?employers=${encodeURIComponent(companyId.toString())}`
</script>
  